import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import Axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import { Button, TextField } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
// import "react-square-payment-form/lib/default.css";
// import {
//   SquarePaymentForm,
//   CreditCardNumberInput,
//   CreditCardExpirationDateInput,
//   CreditCardPostalCodeInput,
//   CreditCardCVVInput,
//   CreditCardSubmitButton,
// } from "react-square-payment-form";
import UseUserState from "../hooks/useUserState";
import DashboardPatient from "../dashboard/DashboardPatient";
import { useLocation } from "react-router-dom";
import CheckoutResume from "./CheckoutResume";
import HeadingResume from "../widgets/HeadingResume";
import mobilePaymentIcon from "../../images/mobile-payment.svg";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import PaypalButton from "./PaypalButton";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function Checkout(props) {
  const location = useLocation();
  let history = useHistory();
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  //jwt received in the email an placed on uri
  let { id } = useParams();
  const [redirectAfterPay, setRedirectAfertPay] = useState(false);

  const [errors, setErrors] = useState([]);
  const userState = UseUserState();
  const {
    appointmentId,
    patient_fullname,
    service_name,
    service_duration,
    price,
  } = location.state;

  //this method manage the backdrop status
  const handleClose = () => {
    setOpen(false);
  };

  const cardNonceResponseReceived = (
    errors,
    nonce,
    cardData,
    buyerVerificationToken
  ) => {
    if (errors) {
      setErrors({ errorMessages: errors?.map((error) => error.message) });
      return;
    }

    //console.log("nonce created: " +nonce +", buyerVerificationToken: " +buyerVerificationToken);
    //console.log("patient", patient_fullname);
    setOpen(true);

    swal({
      title: "Are you sure you want to place the payment?",
      text: "Once accepted we charge the amount to card provided",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((pay) => {
      setOpen(false);
      if (pay) {
        setOpen(true);

        Axios.post(
          `${process.env.REACT_APP_API_URL_BASE}/payments/placePayment`,
          {
            nonce: nonce,
            token: buyerVerificationToken,
            price,
            appointment_id: appointmentId,
          },
          {
            headers: { Authorization: "Bearer " + userState[0].jwt },
          }
        )
          .then((res) => {
            setOpen(false);

            console.log(res);
            swal("success", res.data.title, "success");
            setRedirectAfertPay(true);
          })
          .catch((err) => {
            setErrors({ errorMessages: err });
            setOpen(false);
          });
      }
    });
  };

  const createVerificationDetails = () => {
    console.log(`${price * 100}.00`);
    return {
      amount: `${price * 100}.00`, //"100.00"
      currencyCode: "USD",
      intent: "CHARGE",
      billingContact: {
        familyName: patient_fullname.split(" ")[1], //lastname
        givenName: patient_fullname.split(" ")[0], //firtname
        email: userState[0].user.email,
      },
    };
  };

  useEffect(() => {
    if (redirectAfterPay) {
      setTimeout(() => {
        history.push({
          pathname: "/patient/appointments",
        });
      }, 3000);
    }
  }, [redirectAfterPay]);

  //Handle the response on successfuly payment with paypal
  const handlePaypalSuccess = (response) => {
    if (response) {
      setOpen(true);
      //swal("success", "Payment Success", "success");
      //setRedirectAfertPay(true);
      Axios.post(
        `${process.env.REACT_APP_API_URL_BASE}/payments/paypal/process`,
        {
          paymentStatus: response.status,
          appointment_id: appointmentId,
          serviceResponse: response,
        },
        {
          headers: { Authorization: "Bearer " + userState[0].jwt },
        }
      )
        .then((res) => {
          setOpen(false);
          console.log(res);
          swal("success", "Payment Completed successfuly", "success");
          setRedirectAfertPay(true);
        })
        .catch((err) => {
          setErrors({ errorMessages: err });
          setOpen(false);
        });
    }
  };

  return (
    <DashboardPatient>
      {/* Element that block the screen when request its happen */}
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <HeadingResume
        title="Checkout & Payment"
        description="Once you make the payment we'll notify to Healthcare Provider and we'll send you invoice copy"
        icon={mobilePaymentIcon}
      />
      <div>
        <div className="row m-3 p-3 shadow w-30 rounded-lg-custom bg-white">
          <CheckoutResume
            serviceType={service_name}
            serviceDuration={service_duration}
            price={price}
          />
          <div className="col-md-6 col-sm-12 pl-md-3">
            {/* <SquarePaymentForm
              sandbox={process.env.REACT_APP_SQUARE_SANDBOX_ENV}
              applicationId={process.env.REACT_APP_SQUARE_APP_ID}
              locationId={process.env.REACT_APP_SQUARE_LOCATION_ID}
              cardNonceResponseReceived={cardNonceResponseReceived}
              createVerificationDetails={createVerificationDetails}
            >
              <fieldset className="sq-fieldset">
                <CreditCardNumberInput />
                <div className="sq-form-third">
                  <CreditCardExpirationDateInput />
                </div>

                <div className="sq-form-third">
                  <CreditCardPostalCodeInput />
                </div>

                <div className="sq-form-third">
                  <CreditCardCVVInput />
                </div>
              </fieldset>

              <CreditCardSubmitButton>Place order</CreditCardSubmitButton>
            </SquarePaymentForm> */}
            {/* Paypal Buttons */}
            <div className="mt-2 paypal-buttons text-center">
              <div className="m-2">
                <span>OR PAY WITH</span>
              </div>
              <PaypalButton
                handlePaypalSuccess={handlePaypalSuccess}
                backdropOpen={setOpen}
                amount={`${price}.00`}
              />
            </div>
            <div className="sq-error-message">
              {/* {errors &&
            errors.map((errorMessage) => (
              <li key={`sq-error-${errorMessage}`}>{errorMessage}</li>
            ))} */}
              {errors && (
                <li key={`sq-error-${errors.errorMessage}`}>
                  {errors.errorMessage}
                </li>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardPatient>
  );
}
